function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "format", "moveRow", "onDropped", "rowId", "setDragData"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useContext, useMemo, useState, useEffect } from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useDrag } from "../../../../hooks/use-drag.js";
import { useDrop } from "../../../../hooks/use-drop.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import { Tr } from "../standard-table/tr.js";
import { DndTableDragContext } from "./dnd-table-drag-context.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DndTr = function DndTr(_ref) {
  var children = _ref.children,
    className = _ref.className,
    format = _ref.format,
    moveRow = _ref.moveRow,
    onDropped = _ref.onDropped,
    rowId = _ref.rowId,
    setDragData = _ref.setDragData,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var ref = useRef(null);
  var dragContext = useContext(DndTableDragContext);
  var data = useMemo(function () {
    return {
      rowId: rowId
    };
  }, [rowId]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropped = _useState2[0],
    setDropped = _useState2[1];
  var handleDragEnter = function handleDragEnter() {
    if (dragging) {
      // We're on top of the element being dragged
      return;
    }
    if (data && dragContext.data && dragContext.data.rowId !== data.rowId) {
      // Over a different row, trigger move
      moveRow(dragContext.data.rowId, data.rowId);
    }
  };
  var handleDropped = function handleDropped(dragData, event, format) {
    setDropped(true);
    onDropped(event, format, dragData);
  };
  var handleDragEnd = function handleDragEnd(event) {
    // Emulate "drop" if event wasn't previously fired. As rows are moved around while dragging we want to treat this
    // as a drop even if it was released outside of the table.
    if (!dropped) {
      onDropped(event.nativeEvent, format, data);
    }
    setDropped(false);
  };
  useDrop({
    format: format,
    onDropped: handleDropped,
    ref: ref
  });
  var _useDrag = useDrag({
      format: format,
      data: data,
      ref: ref
    }),
    dragging = _useDrag.dragging;
  useEffect(function () {
    setDragData(dragging ? data : undefined);
    // Changing the opacity is done here with a short delay so the bitmap copy of the element isn't invisible when
    // under the cursor
    setTimeout(function () {
      if (ref.current) {
        ref.current.style.opacity = dragging ? '0' : '1';
      }
    }, 1);
  }, [data, dragging, setDragData]);
  return /*#__PURE__*/React.createElement(Tr, _extends({}, otherProps, {
    ref: ref,
    className: classnames(_defineProperty({
      'bf-table__dnd-tr': true,
      'bf-table__dnd-tr--dragging': dragging
    }, "".concat(className), !!className)),
    onDragEnter: handleDragEnter,
    onDragEnd: handleDragEnd,
    "data-row-id": rowId
  }), children);
};
export { DndTr };